'use strict';

import $ from 'jquery';
import brImg from './templates/_BloomreachImage.hbs';

export default class BloomreachWidget extends Backbone.View {

  initialize() {
    this.imgWrappers = this.$el.find('.br-sf-widget-merchant-img a');
    if (this.imgWrappers.length) {
      this.createImageElements();
    }
  }

  createImageElements() {
    this.imgWrappers.each((idx,imgWrpr) => {
      $(imgWrpr).html(brImg({
        model: imgWrpr.dataset
      }));
    });
  }
}

export function create($parent) {
  if ($parent.find('#br-relatedProductsSearches').length) {
    return new BloomreachWidget({ el: $parent.find('#br-relatedProductsSearches') });
  }
}


// WEBPACK FOOTER //
// ./assets/components/Bloomreach/BloomreachWidget.js